
<template>
    <div class="content">
      <ph-header>
        <van-icon name="arrow-left" size="20px" slot="left" @click="$router.back(-1)" />
      </ph-header>
      <van-address-list
        v-model="chosenAddressId"
        :list="list"
        @add="onAdd"
        @edit="onEdit"
        @select='onChooseAdd'
      />
    </div>
</template>

<script>

import PhHeader from '@/components/common/Header'
import { AddressList } from 'vant'
import { getAddressList, getDefaultAddress, initAreaList } from '@/api/user'

export default {
  components: {
    PhHeader,
    [AddressList.name]: AddressList
  },
  data () {
    return {
      chosenAddressId: '1',
      list: [],
      return_url: ''
    }
  },
  computed: {
    token () {
      return this.$store.getters.token
    },
    IdToAreaCode () {
      return this.$store.getters.defaultAreaList ? this.$store.getters.defaultAreaList.alignmentCorrespondingDictionary : {}
    }
  },
  mounted () {
    if (this.IdToAreaCode) {
      this.getInitAreaList()
    }
    this.return_url = this.$route.query.return_url
    if(this.return_url) {
      this.$store.commit('SET_USER_BALANCE', { return_url: this.return_url })
    }
    
    this.getAddressListData()
  },
  methods: {
    getAddressListData () {
      getAddressList({ userToken: this.token }).then(res => {
        this.list = res.map((item, index) => {
          if (item.defaultAddress === 1) {
            this.chosenAddressId = item.addressId
          }
          return { id: item.addressId, name: item.receiver, tel: item.tel, address: item.connection + item.detailedAddress }
        })
      })
    },
    getInitAreaList () {
      initAreaList().then(res => {
        this.$store.commit('SET_DEFAULT_AREA_LIST', res)
      }).catch(err => {
        this.$toast(err)
      })
    },
    onAdd () {
      this.$router.push({ name: 'addAddress', query: { return_url: this.return_url } })
    },
    onChooseAdd (item, index) {
      this.$store.commit('SET_USER_BALANCE', { addressId: item.id })
      var balance = this.$store.getters.userBalance;
      if(balance.return_url) {
        location.href = balance.return_url
      }
    },

    onEdit (item, index) {
      let id = this.list[index].id
      getDefaultAddress({ addressId: id, userToken: this.token }).then(res => {
        let editAddressData = {}
        editAddressData.id = res.addressId
        editAddressData.tel = res.tel
        editAddressData.name = res.receiver
        editAddressData.areaCode = this.IdToAreaCode[res.areaId]

        editAddressData.addressDetail = res.detailedAddress
        editAddressData.isDefault = res.defaultAddress !== 2
        this.$store.commit('SET_EDIT_ADDRESS', editAddressData)
        this.$router.push({ name: 'editAddress', query: { aid: id } })
      }).catch(err => {
        this.$toast(err)
      })
    }
  }
}

</script>

<style lang="less" scoped>

</style>
